function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 419.535l192-73 192 73"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 405.695l192-73 192 73"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 391.855l192-73 192 73"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 378.015l192-73 192 73"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 364.174l192-73 192 73"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 350.334l192-73 192 73"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 336.495l192-73 192 73"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 322.655l192-73 192 73"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 308.815l192-73 192 73"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 294.975l192-73 192 73"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 281.134l192-73 192 73"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 267.294l192-73 192 73"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 253.455l192-73 192 73"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 239.615l192-73 192 73"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 225.775l192-73 192 73"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 211.935l192-73 192 73"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 198.094l192-73 192 73"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 184.254l192-73 192 73"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 170.415l192-73 192 73"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 156.575l192-73 192 73"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 142.735l192-73 192 73"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 128.895l192-73 192 73"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 115.054l192-73 192 73"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 101.214l192-73 192 73"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 87.374l192-73 192 73"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.178 73.535l192-73 192 73"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 385 421"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

export default __webpack_public_path__ + "static/media/parallel-lines-4.415f5742.svg";
export { SvgComponent as ReactComponent };